"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CLINICAL_APPROVAL_REQUEST_EXAMPLES = exports.validateClinicalCoSignerRequestSchema = exports.resolveClinicalApprovalChainRequestSchema = void 0;
/**
 * Request contracts for the 2 Approval Workflow endpoints. Field
 * shapes mirror `ApprovalWorkflowApplicationService`'s own method
 * signatures (frozen, Stage 6C.3) exactly. `moduleName`/`actionName`
 * are plain strings, not enums — `ClinicalApprovalService
 * .resolveApprovalChain` (Stage 6C.2) is fully generic over both
 * (reused for both Clinical Document `documentType` and Clinical
 * Order `orderType` values, `CLINICAL-APPLICATION-REUSE.md` §12),
 * exactly mirroring `resolveApprovalChainRequestSchema`'s own
 * un-enumerated string fields in `financial-approval.request.ts`.
 */
const zod_1 = require("zod");
const clinical_common_request_1 = require("./clinical-common.request");
exports.resolveClinicalApprovalChainRequestSchema = zod_1.z.object({
    moduleName: zod_1.z.string().min(1),
    actionName: zod_1.z.string().min(1),
    options: clinical_common_request_1.clinicalCallOptionsSchema.optional(),
});
exports.validateClinicalCoSignerRequestSchema = zod_1.z.object({
    moduleName: zod_1.z.string().min(1),
    actionName: zod_1.z.string().min(1),
    coSignerRoleIds: zod_1.z.array(zod_1.z.string().uuid()),
    options: clinical_common_request_1.clinicalCallOptionsSchema.optional(),
});
exports.CLINICAL_APPROVAL_REQUEST_EXAMPLES = {
    resolveClinicalApprovalChain: {
        moduleName: 'clinical',
        actionName: 'ADMISSION_ASSESSMENT',
    },
    validateClinicalCoSigner: {
        moduleName: 'clinical',
        actionName: 'ADMISSION_ASSESSMENT',
        coSignerRoleIds: ['aaaaaaaa-aaaa-aaaa-aaaa-aaaaaaaaaaaa'],
    },
};
//# sourceMappingURL=clinical-approval.request.js.map